import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './estilodashuser.css';
import api from '../api';

export default function Downloads() {
  const { t } = useTranslation();
  const [arquivos, setArquivos] = useState([]);
  const [loading, setLoading] = useState(false);
  const legalNotices = t('dashboard.downloads.legal', { returnObjects: true });

  useEffect(() => {
    const fetchArquivos = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/arquivos');
        setArquivos(response.data || []);
      } catch (error) {
        console.error('Erro ao listar arquivos para download:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchArquivos();
  }, []);

  return (
    <div className="content-page">
      <div className="content-card">
        <div className="content-page-header">
          <div>
            <h2>{t('dashboard.downloads.title')}</h2>
            <p>{t('dashboard.downloads.intro')}</p>
          </div>
        </div>

        <div className="cliente-help-box" style={{ marginBottom: 14 }}>
          <strong>{t('dashboard.downloads.tipTitle')}</strong> {t('dashboard.downloads.tip')}
        </div>

        {loading && <p className="lic-loading">{t('dashboard.downloads.loading')}</p>}

        {!loading && arquivos.length === 0 && (
          <div className="cliente-empty-box">{t('dashboard.downloads.empty')}</div>
        )}

        {!loading && arquivos.length > 0 && (
          <div className="download-grid">
            {arquivos.map((nome, index) => (
              <a
                key={index}
                href={`https://quantumtrades.com.br:8080/downloads/${nome}`}
                download
                className="download-card"
              >
                <div className="download-icon">📦</div>
                <div className="download-name">{nome}</div>
                <div className="download-action">{t('dashboard.downloads.action')}</div>
              </a>
            ))}
          </div>
        )}

        <div className="legal-box">
          <strong>{t('dashboard.downloads.legalTitle')}</strong>
          {Array.isArray(legalNotices) && legalNotices.map((notice) => (
            <p key={notice}>{notice}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
